import { Link } from "wouter";
import { Book } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { HelmLayout } from "./layouts.js";
import { PostTable } from "./table.js";

export function AllPostsPage() {
  return (
    <HelmLayout>
      <div className="space-y-6">
        <div className="flex flex-row items-start gap-3">
          <div className="flex-1">
            <h1 className="text-xl font-semibold">Posts</h1>
            <p className="text-sm text-muted-foreground">
              All posts in this organization, across every phase.
            </p>
          </div>
          <Button asChild variant="outline" size="sm">
            <Link href="/docs">
              <Book className="size-4" />
              Docs
            </Link>
          </Button>
        </div>
        <PostTable />
      </div>
    </HelmLayout>
  );
}
